import { DevPlanListViewMode } from 'generated/CoreApi_v1';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { DevPlanHeader } from 'views/lms/devPlan/Home/components/DevPlanHeader';
import { MyDevPlans } from 'views/lms/devPlan/Home/List/MyDevPlans';


export const UserDevPlans: React.FC = () => {

    const params = useParams();
    const { t } = useTranslation("lms");

    const [userId, setUserId] = useState<string>();

    useEffect(() => {
        if (params.userId) setUserId(params.userId);
    }, [params]);

    return (
        <>
            <DevPlanHeader title={t("DevPlan.Edit.View.Title")} />
            {userId && <MyDevPlans userId={userId} viewMode={DevPlanListViewMode.Manager} />}
        </>
    );
};
